import {usersAPI} from "../API_DAL/api_dal";
import sortingUsers from "../Utilits/SortUsersOrFreinds";

const GET_USERS = "GET_USERS";
const SET_TOTAL_COUNTS = "SET_TOTAL_COUNTS";
const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
const SET_FOLLOW_UNFOLLOW = "SET_FOLLOW_UNFOLLOW";
const SET_ACTIVE_USER_FOLLOWED = "SET_ACTIVE_USER_FOLLOWED";
const ADD_WAITING_SUBSCRIPE = "ADD_WAITING_SUBSCRIPE";
const TOGGLE_PRELOADER = "users/TOGGLE_PRELOADER";
const KEY_TERM_SEARCH = "users/KEY_TERM_SEARCH";

let initialState = {
    users: [],
    totalCount: null,
    activePage: 1,
    pageSize: 8,
    activeUserFollowed: false,
    waitingSubscripe: [],
    isPreloader: false,
    termSearch: ""
};


const usersReducer = (state=initialState, action) => {
    switch (action.type) {
        case GET_USERS:
            return {
                ...state,
                users: action.users
            };
        case SET_TOTAL_COUNTS:
            return {
                ...state,
                totalCount: action.totalCount
            };
        case SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.activePage
            };
        case SET_FOLLOW_UNFOLLOW:
            return {
                ...state,
                users: sortingUsers(state.users, action.id, action.follow),
                activeUserFollowed: action.follow
            };
        case SET_ACTIVE_USER_FOLLOWED:
            return {
                ...state,
                activeUserFollowed: action.follow
            };
        case ADD_WAITING_SUBSCRIPE:
            return {
                ...state,
                waitingSubscripe: action.add ? [...state.waitingSubscripe, action.userId] : state.waitingSubscripe.filter(number => number !== action.userId)
            };
        case TOGGLE_PRELOADER:
            return {
                ...state,
                isPreloader: action.isPreloader
            };
        case KEY_TERM_SEARCH:
            debugger
            return {
                ...state,
                termSearch: action.termSearch
            };
        default:
            return state;
    }
};

export const togglePreloader = (isPreloader) => ({type: TOGGLE_PRELOADER, isPreloader});
const getUsersSuccess = (users) => ({type: GET_USERS, users});
export const setTotalCount = (totalCount) => ({type: SET_TOTAL_COUNTS, totalCount});
export const setActivePage = (activePage) => ({type: SET_ACTIVE_PAGE, activePage});
const setFollowUnFollow = (follow, id) => ({type: SET_FOLLOW_UNFOLLOW, follow, id});
const setActiveUserFollowed = (follow) => ({type: SET_ACTIVE_USER_FOLLOWED, follow});
export const addWaitingSubscribe = (add, userId) => ({type: ADD_WAITING_SUBSCRIPE, add, userId});
export const setTermSearch = (termSearch) => ({type: KEY_TERM_SEARCH, termSearch});


export const getUsers = (pagesCount, pageSize, term) => (dispatch) => {
    dispatch(togglePreloader(true));
    usersAPI.getUser(pagesCount, pageSize, term).then(data => {
        dispatch(getUsersSuccess(data.items));
        dispatch(setTotalCount(data.totalCount));
        dispatch(togglePreloader(false));
    })
};

export const followUnFollow = (id, methodApi, methodAction, dispatch, isFollowed) => {
    dispatch(addWaitingSubscribe(true, id));
    methodApi(id).then(data => {
        if (data.resultCode === 0) {
            dispatch(methodAction(isFollowed, id));
            dispatch(addWaitingSubscribe(false, id));
        }
    })
};

export const follow = (id) => (dispatch) => {
    followUnFollow(id, usersAPI.follow.bind(usersAPI), setFollowUnFollow, dispatch, true)
};

export const unFollow = (id) => (dispatch) => {
    followUnFollow(id, usersAPI.unFollow.bind(usersAPI), setFollowUnFollow, dispatch, false)
};


export const getFollow = (id) => (dispatch) => {
    usersAPI.getFollow(id).then(data => {
        dispatch(setActiveUserFollowed(data))
    })
};


export default usersReducer